import { fromJS } from 'immutable';

const initialState = fromJS({
    elementId: null,
    store_pack_parent_id: null,
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_STORE_PACK_PARENT_ID':
            return state.set('store_pack_parent_id', action.payload);

        default:
            return state;
    }
}
export const setStorePackParentId = (id, elementId) => ({
    type: 'SET_STORE_PACK_PARENT_ID',
    payload: id,
    elementId,  
});